export enum FontSize
{
    fontname = 'fontname' ,
    fontsize = 'fontsize',
    color = 'color',
    
}

